{
  "verticals": {
    "accounting_treatment_simulator": {
      "title": "会计处理模拟器",
      "description": "会计处理影响模拟器(IFRS / US GAAP)"
    },
    "ai_ml": {
      "title": "AI / ML",
      "description": "传统机器学习模型——客户数据、风险评分、保险及交易监控。"
    },
    "allowance_models": {
      "title": "拨备模型",
      "description": "针对批发业务组合的 IFRS 9 / CECL 预期信用损失模型。"
    },
    "alm_interest_rate": {
      "title": "ALM 利率",
      "description": "资产负债管理(ALM)利率预测模型(多情景)"
    },
    "aml_tm": {
      "title": "AML / TM",
      "description": "基于规则的交易监控(TM)——用于侦测可疑交易的情景与阈值逻辑"
    },
    "auto": {
      "title": "汽车金融",
      "description": "汽车贷款与租赁模型——核准评分、残值与损失预测。"
    },
    "auto_allowance": {
      "title": "拨备",
      "description": "汽车贷款 IFRS 9 / CECL 预期信用损失模型"
    },
    "auto_irb_lgd": {
      "title": "IRB LGD",
      "description": "汽车贷款违约损失率——车辆折旧与回收建模"
    },
    "auto_irb_pd": {
      "title": "IRB PD",
      "description": "汽车贷款违约概率——核准与行为模型"
    },
    "auto_scorecard": {
      "title": "评分卡",
      "description": "汽车贷款核准与行为评分卡"
    },
    "balance_sheet_optimizer": {
      "title": "资产负债表优化器",
      "description": "资产负债表优化求解器(LP / NLP)"
    },
    "behavioral_models": {
      "title": "行为模型",
      "description": "存款黏性、提前还款及可赎回产品行权行为建模。"
    },
    "bond_futures": {
      "title": "国债期货",
      "description": "国债期货定价与最便宜可交割券(CTD)分析"
    },
    "bond_options": {
      "title": "债券期权",
      "description": "国债及国债期货上的期权"
    },
    "borrower_risk_rating": {
      "title": "借款人风险评级",
      "description": "结合财务与定性因素的借款人层级信用资质评估"
    },
    "callable_bond": {
      "title": "可赎回债券",
      "description": "含发行人赎回选择权、需进行期权调整利差(OAS)分析的债券"
    },
    "callable_product_exercise": {
      "title": "可赎回产品行权",
      "description": "可赎回产品行权模型(消费与企业)"
    },
    "cancellable_swap": {
      "title": "可取消利率掉期",
      "description": "含百慕大式取消权(单方或双方)的利率掉期"
    },
    "capital_funding_management": {
      "title": "资本与融资管理",
      "description": "监管资本模拟、经济资本归集及融资优化。"
    },
    "capital_planning_scenario": {
      "title": "资本规划情景",
      "description": "资本规划情景引擎(ICAAP / CCAR 输入)"
    },
    "cards": {
      "title": "信用卡",
      "description": "信用卡组合模型——行为评分、损失预测与额度管理。"
    },
    "cards_allowance": {
      "title": "拨备",
      "description": "信用卡 IFRS 9 / CECL 预期信用损失模型"
    },
    "cards_irb_ead": {
      "title": "IRB EAD",
      "description": "信用卡违约风险敞口——使用率与信用转换因子"
    },
    "cards_irb_lgd": {
      "title": "IRB LGD",
      "description": "信用卡违约损失率——回收与核销建模"
    },
    "cards_irb_pd": {
      "title": "IRB PD",
      "description": "信用卡违约概率——行为评分与逾期迁移"
    },
    "cards_scorecard": {
      "title": "评分卡",
      "description": "信用卡核准与行为评分卡"
    },
    "cash_allocation": {
      "title": "现金配置",
      "description": "现金配置与短期投资优化器"
    },
    "ccr": {
      "title": "CCR",
      "description": "交易对手信用风险模型——SA-CCR、PFE / EE 敞口模拟及回溯测试。"
    },
    "ccr_backtesting": {
      "title": "CCR 回溯测试",
      "description": "CCR 敞口模型对实际盯市价值的回溯测试"
    },
    "cds": {
      "title": "CDS",
      "description": "单一名称信用违约互换——保护定价与信用利差建模"
    },
    "cdx": {
      "title": "CDX",
      "description": "信用违约互换指数——组合信用风险定价与基差交易"
    },
    "cdx_options": {
      "title": "CDX 期权",
      "description": "CDX 指数上的期权——信用利差波动率与偏度建模"
    },
    "clearing_settlement_queue": {
      "title": "清算结算队列",
      "description": "清算与结算队列模型"
    },
    "client_risk_rating": {
      "title": "客户风险评级",
      "description": "客户风险评级(CRR)——评分卡、确定性及基于机器学习的客户风险分类。"
    },
    "commodity": {
      "title": "大宗商品",
      "description": "大宗商品衍生品定价模型。"
    },
    "commodity_american_option": {
      "title": "大宗商品美式期权",
      "description": "可提前行权、需考虑仓储成本的美式商品期权"
    },
    "commodity_cap_and_floor": {
      "title": "大宗商品上限与下限",
      "description": "提供成本 / 收入保护的大宗商品价格上限与下限"
    },
    "commodity_european_option": {
      "title": "大宗商品欧式期权",
      "description": "针对商品期货或现货价格的欧式期权"
    },
    "commodity_swap": {
      "title": "大宗商品掉期",
      "description": "能源、金属及农产品指数上的固定换浮动商品掉期"
    },
    "commodity_swaptions": {
      "title": "大宗商品掉期期权",
      "description": "以预定固定价格进入商品掉期的期权"
    },
    "contingency_funding": {
      "title": "应急融资",
      "description": "应急融资计划模拟器(提款序列器)"
    },
    "convertible_bond": {
      "title": "可转换债券",
      "description": "嵌入股权转换期权的混合型债务工具"
    },
    "credit": {
      "title": "信用",
      "description": "信用衍生品定价模型。"
    },
    "credit_risk": {
      "title": "信用风险",
      "description": "批发与零售信用风险模型——风险评级、IRB 参数、拨备及压力测试。"
    },
    "cross_currency_swap": {
      "title": "交叉货币掉期",
      "description": "含本金交换与外汇重置特征的交叉货币基差掉期"
    },
    "cva": {
      "title": "CVA",
      "description": "信用估值调整模型——会计 CVA 及监管 SA-CVA。"
    },
    "cva_fva_dva_calculator": {
      "title": "CVA / FVA / DVA 计算器",
      "description": "CVA / FVA / DVA 计算器"
    },
    "cva_model": {
      "title": "CVA",
      "description": "会计 CVA——衍生品组合对手方违约的预期损失"
    },
    "deposit_behavioral_runoff": {
      "title": "存款行为流出",
      "description": "存款行为流出模型(核心 vs 非核心)"
    },
    "deposit_behavioral_segmentation": {
      "title": "存款行为分群",
      "description": "存款行为分群模型"
    },
    "derivative_pricing_models": {
      "title": "衍生品定价模型",
      "description": "对外汇、股票、利率、大宗商品及信用各资产类别的衍生品定价模型进行验证。"
    },
    "deterministic_crr": {
      "title": "确定性 CRR",
      "description": "确定性 CRR——基于确定性规则的客户风险评级"
    },
    "direct_cf_hedge": {
      "title": "直接现金流套期",
      "description": "直接现金流套期有效性引擎"
    },
    "direct_fv_hedge": {
      "title": "直接公允价值套期",
      "description": "直接公允价值套期有效性引擎"
    },
    "dynamic_cf_hedge": {
      "title": "动态现金流套期",
      "description": "动态现金流套期有效性引擎"
    },
    "dynamic_fv_hedge": {
      "title": "动态公允价值套期",
      "description": "动态公允价值套期有效性引擎"
    },
    "economic_capital": {
      "title": "经济资本",
      "description": "经济资本分配模型(风险归集)"
    },
    "effectiveness_testing": {
      "title": "套期有效性测试",
      "description": "在 IFRS 9 与 US GAAP(ASC 815)框架下的套期有效性评估。"
    },
    "equity": {
      "title": "股票",
      "description": "股票衍生品定价模型。"
    },
    "equity_american_option": {
      "title": "股票美式期权",
      "description": "可提前行权的美式股票期权"
    },
    "equity_asian_option": {
      "title": "股票亚式期权",
      "description": "支付与平均价或平均执行价相关的路径依赖型股票期权"
    },
    "equity_autocallable_note": {
      "title": "股票自动赎回票据",
      "description": "在票息观察日具备自动提前赎回机制的结构化票据"
    },
    "equity_barrier_option": {
      "title": "股票障碍期权",
      "description": "在指定障碍水平触发或失效的股票期权"
    },
    "equity_digital_option": {
      "title": "股票数字期权",
      "description": "以到期是否处于价内决定固定支付的股票期权"
    },
    "equity_european_option": {
      "title": "股票欧式期权",
      "description": "仅可在到期日行权的香草型欧式股票期权"
    },
    "equity_forward": {
      "title": "股票远期",
      "description": "单一股票或股票指数上的远期合约"
    },
    "equity_forward_starting_option": {
      "title": "股票远期起始期权",
      "description": "执行价在交易开始之后某一定盘日才确定的股票期权"
    },
    "equity_futures": {
      "title": "股票期货",
      "description": "在交易所交易的股票指数及单一股票期货"
    },
    "equity_touch_option": {
      "title": "股票触碰期权",
      "description": "触及障碍即支付固定金额的二元股票期权"
    },
    "eve_calculator": {
      "title": "EVE 计算器",
      "description": "经济价值(EVE)计算器(监管冲击套件)"
    },
    "facility_risk_rating": {
      "title": "授信工具风险评级",
      "description": "结合抵押、结构与受偿顺序的授信工具层级风险评估"
    },
    "fair_value_hierarchy": {
      "title": "公允价值层级",
      "description": "公允价值层级对账器"
    },
    "financial_crimes": {
      "title": "金融犯罪",
      "description": "反洗钱(AML)交易监控、客户风险评级及制裁筛查模型。"
    },
    "financial_resource_optimization": {
      "title": "金融资源优化",
      "description": "内部资金转移定价、资产负债表优化、资本与融资管理。"
    },
    "fraud": {
      "title": "欺诈",
      "description": "欺诈侦测与防范模型——交易、账户、登录及理赔欺诈评分。"
    },
    "fraud_account_scoring": {
      "title": "账户评分",
      "description": "基于银行账户关联关系的欺诈风险评分平台"
    },
    "fraud_call_risk_scoring": {
      "title": "电话风险评分",
      "description": "电话风险评估与优先级排序解决方案"
    },
    "fraud_credit_card_claims": {
      "title": "信用卡争议",
      "description": "信用卡争议欺诈可能性评估系统"
    },
    "fraud_credit_risk": {
      "title": "信用风险",
      "description": "住宅按揭申请风险分类器"
    },
    "fraud_data_loss_prevention": {
      "title": "数据泄漏防护",
      "description": "员工打印行为异常侦测系统"
    },
    "fraud_insurance_investigation": {
      "title": "保险调查",
      "description": "车险理赔调查建议解决方案"
    },
    "fraud_login_portal": {
      "title": "登录门户",
      "description": "在线与移动登录门户欺诈侦测解决方案"
    },
    "fraud_online_banking": {
      "title": "网上银行",
      "description": "网上银行交易风险评分与监控系统"
    },
    "fraud_transaction_detection": {
      "title": "交易侦测",
      "description": "针对 ATM、移动、提现及借记交易的实时异常侦测"
    },
    "fraud_transaction_monitoring": {
      "title": "交易监控",
      "description": "高风险电汇交易评分解决方案"
    },
    "fraud_wealth_segmentation": {
      "title": "财富分群",
      "description": "财富组合分群与特征选择"
    },
    "ftp_curve_construction": {
      "title": "FTP 曲线构建",
      "description": "资金转移定价(FTP)曲线构建与校准模块"
    },
    "funding_concentration": {
      "title": "融资集中度",
      "description": "融资集中度与对手方敞口模型(ICAAP / CCAR 输入)"
    },
    "funding_cost_allocation": {
      "title": "融资成本分摊",
      "description": "融资成本分摊模型(交易级 FTP)"
    },
    "funding_mix_optimization": {
      "title": "融资结构优化",
      "description": "融资结构与期限优化模型"
    },
    "funding_mix_tenor": {
      "title": "融资结构与期限",
      "description": "融资结构与期限优化模型(成本 vs 流动性)"
    },
    "funds_transfer_pricing": {
      "title": "资金转移定价",
      "description": "业务线与司库之间资金的内部定价。"
    },
    "fx": {
      "title": "外汇",
      "description": "外汇衍生品定价模型。"
    },
    "fx_american_option": {
      "title": "外汇美式期权",
      "description": "到期前任意时点均可行权的美式外汇期权"
    },
    "fx_asian_option": {
      "title": "外汇亚式期权",
      "description": "支付基于一段期间内平均汇率的路径依赖型外汇期权"
    },
    "fx_barrier_option": {
      "title": "外汇障碍期权",
      "description": "现汇汇率穿越障碍水平时触发或失效的外汇期权"
    },
    "fx_digital_option": {
      "title": "外汇数字期权",
      "description": "以现汇收盘高于或低于执行价决定固定支付的外汇期权"
    },
    "fx_european_option": {
      "title": "外汇欧式期权",
      "description": "仅可在到期日行权的香草型欧式外汇期权"
    },
    "fx_forward": {
      "title": "外汇远期",
      "description": "未来日期交割的货币对全额远期合约"
    },
    "fx_futures": {
      "title": "外汇期货",
      "description": "在交易所交易的标准化货币期货合约"
    },
    "fx_range_accrual": {
      "title": "外汇区间累积",
      "description": "票息按现汇停留于区间内的天数累积的结构化外汇票据"
    },
    "fx_touch_option": {
      "title": "外汇触碰期权",
      "description": "现汇触及指定水平即支付固定金额的二元外汇期权"
    },
    "genai": {
      "title": "GenAI",
      "description": "生成式 AI 模型——核保、监察、代码生成、聊天机器人及摘要。"
    },
    "genai_carrier_booklet_extraction": {
      "title": "原承保人手册抽取",
      "description": "原承保人手册数据抽取与结构化工具"
    },
    "genai_chatbots": {
      "title": "聊天机器人",
      "description": "内部知识与支持聊天机器人生态"
    },
    "genai_code_assistant": {
      "title": "代码助手",
      "description": "开发者效率与代码生成助手套件"
    },
    "genai_code_conversion": {
      "title": "代码转换",
      "description": "遗留 FOCUS 代码解释与转换平台"
    },
    "genai_comms_monitoring": {
      "title": "通讯监控",
      "description": "员工通讯监控与合规侦测系统"
    },
    "genai_news_classification": {
      "title": "新闻分类",
      "description": "外部新闻事件分类与摘要解决方案"
    },
    "genai_summarization": {
      "title": "摘要",
      "description": "客服中心通话自动摘要平台"
    },
    "genai_surveillance": {
      "title": "监察",
      "description": "面向合规风险侦测的员工通讯与语音监察。"
    },
    "genai_underwriting": {
      "title": "核保",
      "description": "GenAI 驱动的核保建议与数据抽取。"
    },
    "genai_underwriting_recommendation": {
      "title": "核保建议",
      "description": "自动化核保建议与辅助平台"
    },
    "genai_voice_surveillance": {
      "title": "语音监察",
      "description": "员工语音通讯监察与风险侦测"
    },
    "hedge_accounting": {
      "title": "套期会计",
      "description": "套期估值与有效性测试模型。"
    },
    "hedge_rebalancing_backtest": {
      "title": "套期再平衡回溯测试",
      "description": "套期再平衡与有效性回溯测试模型"
    },
    "hedge_rebalancing_scheduler": {
      "title": "套期再平衡调度器",
      "description": "套期再平衡调度器与交易建议模块"
    },
    "heloc": {
      "title": "HELOC",
      "description": "房屋净值循环授信(HELOC)模型——提款行为、抵押物监控及损失预测。"
    },
    "heloc_allowance": {
      "title": "拨备",
      "description": "HELOC 的 IFRS 9 / CECL 预期信用损失模型"
    },
    "heloc_irb_ead": {
      "title": "IRB EAD",
      "description": "HELOC 违约风险敞口——提款行为与使用率建模"
    },
    "heloc_irb_lgd": {
      "title": "IRB LGD",
      "description": "HELOC 违约损失率——综合留置位次与物业价值建模"
    },
    "heloc_irb_pd": {
      "title": "IRB PD",
      "description": "HELOC 违约概率——按揭与循环授信综合风险因子"
    },
    "intraday_limit_breach": {
      "title": "日间限额突破",
      "description": "日间限额突破预测器"
    },
    "intraday_liquidity_engine": {
      "title": "日间流动性引擎",
      "description": "支付流模拟器"
    },
    "ir": {
      "title": "利率",
      "description": "利率衍生品定价模型。"
    },
    "ir_bermudan_swaption": {
      "title": "利率百慕大式互换期权",
      "description": "具备多个行权日、需采用树形 / 蒙特卡洛方法的百慕大式互换期权"
    },
    "ir_range_accrual": {
      "title": "利率区间累积",
      "description": "票息按参考利率停留于走廊内的天数累积的利率区间累积票据"
    },
    "ir_cap_and_floor": {
      "title": "利率上限与下限",
      "description": "利率上限与下限——浮动利率上的 caplet / floorlet 组合"
    },
    "ir_european_swaption": {
      "title": "利率欧式互换期权",
      "description": "欧式互换期权——在到期日以固定利率进入利率掉期的权利"
    },
    "ir_future_options": {
      "title": "利率期货期权",
      "description": "短期利率期货合约上的期权"
    },
    "ir_futures": {
      "title": "利率期货",
      "description": "短期利率期货(欧洲美元、SOFR)的定价与凸性调整"
    },
    "ir_swap": {
      "title": "利率掉期",
      "description": "采用多曲线贴现的香草型与基差利率掉期"
    },
    "irb_parameter_models": {
      "title": "IRB 参数模型",
      "description": "用于监管资本的内部评级法(IRB)参数估计。"
    },
    "irrbb_measurement": {
      "title": "IRRBB 计量",
      "description": "经济价值与净利息收入对利率变动的敏感度。"
    },
    "irrbb_reporting_reconciler": {
      "title": "IRRBB 报送对账器",
      "description": "IRRBB 报送对账器"
    },
    "isda_simm": {
      "title": "ISDA SIMM",
      "description": "ISDA SIMM——基于敏感度、跨风险类别的初始保证金计算"
    },
    "issuance_timing": {
      "title": "发行时机",
      "description": "发行时机与定价优化器"
    },
    "lcr_calculator": {
      "title": "LCR 计算器",
      "description": "高频对账模块"
    },
    "lcr_nsfr_nccf_mapping": {
      "title": "LCR / NSFR / NCCF 映射",
      "description": "LCR / NSFR / NCCF 现金流映射引擎"
    },
    "liquidity": {
      "title": "流动性",
      "description": "监管报送、短期预测、长期规划及压力测试。"
    },
    "liquidity_buffer_drawdown": {
      "title": "流动性缓冲提取",
      "description": "流动性缓冲提取模型(资产变现序列器)"
    },
    "liquidity_cost_minimization": {
      "title": "流动性成本最小化",
      "description": "流动性成本最小化模型(惩罚函数)"
    },
    "liquidity_ratio_reconciler": {
      "title": "流动性比率对账器",
      "description": "报送包生成器"
    },
    "liquidity_stress": {
      "title": "流动性压力",
      "description": "流动性压力情景引擎(监管与内部情景)"
    },
    "long_term_planning": {
      "title": "长期规划",
      "description": "中长期流动性预测、到期管理及行为建模。"
    },
    "machine_learning": {
      "title": "机器学习模型",
      "description": "覆盖保险、银行及企业领域的 AI / ML、NLP、GenAI 及欺诈侦测模型。"
    },
    "market_risk": {
      "title": "市场风险",
      "description": "面向交易组合与衍生品的 VaR / ES、交易对手信用风险、CVA 及 SIMM 模型。"
    },
    "maturity_ladder": {
      "title": "到期梯度",
      "description": "到期梯度汇总与滚动引擎"
    },
    "medium_term_liquidity": {
      "title": "中期流动性",
      "description": "中期流动性预测 1-12 个月(情景混合)"
    },
    "ml_based_crr": {
      "title": "ML 基础 CRR",
      "description": "基于机器学习的 CRR——基于机器学习的客户风险分类"
    },
    "ml_based_tm": {
      "title": "ML 基础 TM",
      "description": "基于机器学习的 TM——基于特征的训练模型(梯度提升树、NLP、GenAI)"
    },
    "ml_credit_distress_prediction": {
      "title": "信用困境预测",
      "description": "业务合作方信用困境预测平台"
    },
    "ml_credit_risk_assessment": {
      "title": "信用风险评估",
      "description": "由机器学习驱动的信用风险预测、分群及分类模型。"
    },
    "ml_customer_data_mgmt": {
      "title": "客户数据管理",
      "description": "客户人口统计对账与匹配引擎"
    },
    "ml_data_loss_prevention": {
      "title": "数据泄漏防护",
      "description": "员工打印行为异常侦测系统"
    },
    "ml_etl_preprocessing": {
      "title": "ETL / 预处理",
      "description": "数据抽取、转换与特征工程流水线"
    },
    "ml_high_risk_wire_scoring": {
      "title": "高风险电汇交易评分",
      "description": "高风险电汇交易评分解决方案"
    },
    "ml_insurance_investigation": {
      "title": "保险调查",
      "description": "车险理赔调查建议解决方案"
    },
    "ml_insurance_pricing": {
      "title": "保险定价",
      "description": "住宅险理赔损失程度预测工具"
    },
    "ml_insurance_underwriting": {
      "title": "保险核保",
      "description": "实时人寿保险核保决策系统"
    },
    "ml_marketing": {
      "title": "营销",
      "description": "零售客户营销推荐引擎"
    },
    "ml_mortgage_risk_classifier": {
      "title": "按揭风险分类器",
      "description": "住宅按揭申请风险分类器"
    },
    "ml_transaction_monitoring": {
      "title": "交易监控",
      "description": "面向电汇的基于机器学习的交易评分与告警降噪。"
    },
    "ml_wealth_portfolio_selection": {
      "title": "财富组合特征选择",
      "description": "财富组合分群与特征选择"
    },
    "ml_wealth_segmentation": {
      "title": "财富客户分群",
      "description": "财富客户分群与顾问聚类"
    },
    "ml_wire_alert_reduction": {
      "title": "电汇告警降噪",
      "description": "个人银行电汇告警降噪系统"
    },
    "mortgage": {
      "title": "按揭",
      "description": "住宅按揭贷款模型——IRB 参数、评分卡、拨备及压力测试。"
    },
    "mortgage_allowance": {
      "title": "拨备",
      "description": "结合房价指数(HPI)情景的按揭 IFRS 9 / CECL 预期信用损失模型"
    },
    "mortgage_irb_ead": {
      "title": "IRB EAD",
      "description": "按揭违约风险敞口——摊销、提前还款及 HELOC 提款建模"
    },
    "mortgage_irb_lgd": {
      "title": "IRB LGD",
      "description": "按揭违约损失率——抵押品估值、回收率及保险覆盖"
    },
    "mortgage_irb_pd": {
      "title": "IRB PD",
      "description": "按揭违约概率——池分群、校准及按 OSFI CAR 设置的监管下限"
    },
    "mortgage_scorecard": {
      "title": "评分卡",
      "description": "用于信贷决策的按揭核准与行为评分卡"
    },
    "mortgage_stress": {
      "title": "压力测试",
      "description": "不利住房与宏观情景下的按揭压力损失预测"
    },
    "name_screening": {
      "title": "名单筛查",
      "description": "对客户 / 对手方名称进行制裁与监控名单匹配"
    },
    "nii_projection": {
      "title": "NII 预测",
      "description": "净利息收入(NII)预测模型(基准、不利、严重)"
    },
    "nii_shock_simulator": {
      "title": "NII 冲击模拟器",
      "description": "NII 冲击模拟器(平行、扭转、自定义)"
    },
    "nlp": {
      "title": "NLP",
      "description": "自然语言处理模型——分类、实体识别、情感及摘要。"
    },
    "nlp_chatbots": {
      "title": "聊天机器人",
      "description": "内部员工支持与信息聊天机器人套件"
    },
    "nlp_document_masking": {
      "title": "文档脱敏",
      "description": "调研评论匿名化与个人身份信息(PII)脱敏解决方案"
    },
    "nlp_intent_classification": {
      "title": "意图分类",
      "description": "客服中心客户意图分类平台"
    },
    "nlp_marketing_asset_analysis": {
      "title": "营销素材分析",
      "description": "社交媒体营销素材评估与评分解决方案"
    },
    "nlp_named_entity_recognition": {
      "title": "命名实体识别",
      "description": "调研评论中个人姓名识别与脱敏"
    },
    "nlp_news_classification": {
      "title": "新闻分类",
      "description": "用于审计计划的外部新闻事件分类"
    },
    "nlp_sentiment_analysis": {
      "title": "情感分析",
      "description": "调研评论情感侦测与标注系统"
    },
    "nlp_summarization": {
      "title": "摘要",
      "description": "客服中心通话摘要与转写工具"
    },
    "nlp_topic_classification": {
      "title": "主题分类",
      "description": "调研评论主题分类与分析工具"
    },
    "ois_discounting": {
      "title": "OIS 贴现",
      "description": "OIS 贴现与基差调整模块"
    },
    "operational_risk_simulator": {
      "title": "操作风险模拟器",
      "description": "操作风险模拟器(ICAAP / CCAR 输入)"
    },
    "option_adjusted_valuation": {
      "title": "期权调整估值",
      "description": "期权调整估值(OAV)模型"
    },
    "parameter_calibration": {
      "title": "参数校准",
      "description": "用于敞口模拟的漂移、波动率及相关性参数校准"
    },
    "payment_flow_concentration": {
      "title": "支付流集中度",
      "description": "支付流集中度分析器"
    },
    "payment_screening": {
      "title": "支付筛查",
      "description": "支付报文对制裁名单的筛查"
    },
    "personal_allowance": {
      "title": "拨备",
      "description": "个人贷款 IFRS 9 / CECL 预期信用损失模型"
    },
    "personal_irb_lgd": {
      "title": "IRB LGD",
      "description": "个人贷款违约损失率——无抵押回收建模"
    },
    "personal_irb_pd": {
      "title": "IRB PD",
      "description": "个人贷款违约概率——无抵押风险评估"
    },
    "personal_lending": {
      "title": "个人贷款",
      "description": "无抵押个人贷款与循环授信模型。"
    },
    "personal_scorecard": {
      "title": "评分卡",
      "description": "个人贷款核准与行为评分卡"
    },
    "pfe_ee": {
      "title": "PFE / EE",
      "description": "潜在未来敞口(PFE)与预期敞口(EE)模拟模型。"
    },
    "precious_metal_range_accrual": {
      "title": "贵金属区间累积",
      "description": "票息按金 / 银价格停留于区间内累积的结构化票据"
    },
    "prepayment_cpr": {
      "title": "提前还款 CPR",
      "description": "提前还款 / CPR 模型(按揭账龄与衰减)"
    },
    "rate_scenario_monte_carlo": {
      "title": "利率情景蒙特卡洛",
      "description": "利率情景蒙特卡洛引擎(随机路径)"
    },
    "recovery_funding": {
      "title": "恢复融资",
      "description": "恢复融资序列器(融资来源优先级)"
    },
    "regulatory_capital_simulator": {
      "title": "监管资本模拟器",
      "description": "监管资本影响模拟器(巴塞尔协议 / Basel)"
    },
    "regulatory_reporting": {
      "title": "监管报送",
      "description": "LCR、NSFR 及 NCCF 监管流动性比率的计算与对账。"
    },
    "repricing_ladder": {
      "title": "重定价梯度",
      "description": "重定价梯度汇总器(按区间与产品)"
    },
    "retail": {
      "title": "零售",
      "description": "面向消费贷款组合的零售信用风险模型。"
    },
    "retail_deposit_stickiness": {
      "title": "零售存款黏性",
      "description": "零售存款黏性与衰减模型"
    },
    "reverse_liquidity_stress": {
      "title": "反向流动性压力",
      "description": "反向流动性压力测试器(特异性与市场)"
    },
    "risk_rating_models": {
      "title": "风险评级模型",
      "description": "借款人与授信工具层级的信用风险评级模型。"
    },
    "run_off_roll_rate": {
      "title": "流出与迁移率",
      "description": "流出与迁移率模型(按产品)"
    },
    "sa_ccr": {
      "title": "SA-CCR",
      "description": "交易对手信用风险标准法(SA-CCR)——监管 EAD 计算"
    },
    "sa_cva": {
      "title": "SA-CVA",
      "description": "标准法 CVA(SA-CVA)——针对 CVA 风险的监管资本要求(FRTB)"
    },
    "sabr_vol_calibration": {
      "title": "SABR 波动率校准",
      "description": "针对互换期权与 cap / floor 波动率曲面的 SABR 随机波动率模型校准"
    },
    "sanctions_screening": {
      "title": "制裁筛查",
      "description": "对制裁与监控名单进行名称筛查与支付筛查。"
    },
    "scenario_asset_allocation": {
      "title": "情景资产配置",
      "description": "基于情景的资产配置引擎(感知压力)"
    },
    "scorecard_ph": {
      "title": "PH 评分卡",
      "description": "基于评分卡的 PH——针对潜在高风险(PH)客户带加强尽职调查(EDD)阈值的加和式评分"
    },
    "short_term_cashflow_branch": {
      "title": "短期现金流(分行)",
      "description": "短期现金流预测(分行与批发)"
    },
    "short_term_cashflow_treasury": {
      "title": "短期现金流(司库)",
      "description": "短期现金流预测(司库台)"
    },
    "short_term_forecasting": {
      "title": "短期预测",
      "description": "用于司库运营的日间与短期现金流预测。"
    },
    "simm": {
      "title": "SIMM",
      "description": "用于非中央清算 OTC 衍生品的标准初始保证金模型(SIMM)。"
    },
    "simm_backtesting": {
      "title": "回溯测试",
      "description": "SIMM 回溯测试——根据实际损益验证保证金充足性"
    },
    "simulation_exposure_generation": {
      "title": "模拟与敞口生成",
      "description": "用于生成 PFE / EE 曲线的蒙特卡洛模拟引擎"
    },
    "strategic_ftp": {
      "title": "战略 FTP",
      "description": "战略 FTP 优化器(业务线利差)"
    },
    "stress_funding_recovery": {
      "title": "压力融资恢复",
      "description": "压力融资与恢复规划器(监管情景)"
    },
    "stress_period_selection": {
      "title": "压力期选择",
      "description": "压力 VaR 校准——识别历史上最不利的压力窗口"
    },
    "stress_testing_aggregation": {
      "title": "压力测试",
      "description": "流动性压力情景引擎、反向压力测试及应急融资。"
    },
    "stress_testing_models": {
      "title": "压力测试模型",
      "description": "面向 ICAAP、CCAR 及监管情景的压力测试参数模型。"
    },
    "structural_market_risk": {
      "title": "结构性(非交易)市场风险",
      "description": "IRRBB 计量、行为模型及收益率曲线构建。"
    },
    "transaction_monitoring": {
      "title": "交易监控",
      "description": "反洗钱 / 反恐怖融资(AML / ATF)交易监控——基于规则与基于机器学习的侦测模型。"
    },
    "transactional_ftp": {
      "title": "交易级 FTP",
      "description": "交易级 FTP 引擎(逐笔交易)"
    },
    "treasury": {
      "title": "财资",
      "description": "流动性、结构性市场风险、金融资源优化及套期会计模型。"
    },
    "treasury_portfolio_rebalancer": {
      "title": "司库组合再平衡器",
      "description": "司库组合再平衡器(久期与流动性目标)"
    },
    "valuation": {
      "title": "估值",
      "description": "公允价值计量,包括 CVA、FVA、DVA 及估值层级。"
    },
    "var_es": {
      "title": "VaR / ES",
      "description": "用于交易账簿风险计量的风险价值(VaR)与预期亏损(ES)模型。"
    },
    "var_es_engine": {
      "title": "VaR / ES 引擎",
      "description": "历史模拟法、参数法及蒙特卡洛 VaR / ES 计算引擎"
    },
    "wholesale": {
      "title": "批发",
      "description": "面向商业、企业及金融机构敞口的批发信用风险模型。"
    },
    "wholesale_ead_calibration": {
      "title": "EAD 校准",
      "description": "信用转换因子估计与 EAD 校准"
    },
    "wholesale_ead_segmentation": {
      "title": "EAD 分群",
      "description": "针对循环授信与定期授信的违约风险敞口分群"
    },
    "wholesale_ecl_ead": {
      "title": "ECL EAD",
      "description": "用于 ECL 的全生命周期 EAD 估计,涵盖摊销与提款曲线"
    },
    "wholesale_ecl_lgd": {
      "title": "ECL LGD",
      "description": "用于 ECL 的全生命周期 LGD 估计,含回收曲线建模"
    },
    "wholesale_ecl_pd": {
      "title": "ECL PD",
      "description": "用于 ECL 估计、含前瞻性信息的时点 PD"
    },
    "wholesale_lgd_calibration": {
      "title": "LGD 校准",
      "description": "结合追偿与回收建模的下行 LGD 校准"
    },
    "wholesale_lgd_segmentation": {
      "title": "LGD 分群",
      "description": "按抵押品类型与受偿顺序划分的违约损失率分群"
    },
    "wholesale_pd_calibration": {
      "title": "PD 校准",
      "description": "长期平均 PD 校准与保守边际(MoC)"
    },
    "wholesale_pd_segmentation": {
      "title": "PD 分群",
      "description": "违约概率风险分群与池分配"
    },
    "wholesale_sicr": {
      "title": "SICR",
      "description": "信用风险显著上升(SICR)分阶段模型(Stage 1 / 2 / 3 划分)"
    },
    "wholesale_stress_ead": {
      "title": "压力 EAD",
      "description": "压力情景下含提款行为的 EAD 估计"
    },
    "wholesale_stress_lgd": {
      "title": "压力 LGD",
      "description": "下行情景下的 LGD 估计"
    },
    "wholesale_stress_pd": {
      "title": "压力 PD",
      "description": "不利宏观情景下的 PD 预测"
    },
    "yield_curve_construction": {
      "title": "收益率曲线构建",
      "description": "收益率曲线构建与自助法(Bootstrapping)引擎"
    },
    "yield_curve_models": {
      "title": "收益率曲线模型",
      "description": "收益率曲线构建、自助法及多曲线框架。"
    },
    "capital_models": {
      "title": "资本模型",
      "description": "市场风险下的资本模型——交易账簿监管资本计算与 FRTB 相关方法。"
    },
    "frtb": {
      "title": "FRTB",
      "description": "交易账簿基本性审查(FRTB)——市场风险资本下的标准法(SA)与内部模型法(IMA)。"
    },
    "insurance": {
      "title": "保险",
      "description": "保险与精算模型——定价、准备金、资本及经验分析。"
    },
    "life": {
      "title": "寿险",
      "description": "寿险与年金模型——定价、评估、资本及经验分析。"
    },
    "life_valuation": {
      "title": "估值",
      "description": "计算保险公司针对寿险保单的负债、准备金及财务结果。"
    },
    "p_and_c": {
      "title": "财产险",
      "description": "财产与意外险模型——定价、准备金及资本。"
    },
    "pricing": {
      "title": "定价",
      "description": "定价与费率厘定模型。"
    },
    "reserving": {
      "title": "准备金",
      "description": "赔款准备金与负债评估模型。"
    }
  },
  "serviceTypes": {
    "Auditing": {
      "title": "审计",
      "description": "对模型治理、控制及监管合规进行全面审计"
    },
    "Development": {
      "title": "开发",
      "description": "模型开发、增强及文档支持"
    },
    "Validation": {
      "title": "验证",
      "description": "对模型假设、方法论及输出进行独立审查与验证"
    }
  },
  "generic": {
    "title": "通用任务",
    "description": "对不属于预定义类别的模型进行验证或审计。"
  },
  "inventory": {
    "models": {
      "1": {
        "name": "信用风险 PD 模型 v2.1",
        "type": "信用风险",
        "description": "针对零售按揭组合的违约概率(PD)模型",
        "owner": "风险分析团队",
        "regulatoryFramework": "巴塞尔协议 III (Basel III)",
        "modelCategory": "零售",
        "dataSource": "内部信用数据库"
      },
      "3": {
        "name": "EAD 计算模型",
        "type": "信用风险",
        "description": "用于信用风险资本要求的违约风险敞口(EAD)计算",
        "owner": "资本管理",
        "regulatoryFramework": "巴塞尔协议 III (Basel III)",
        "modelCategory": "批发",
        "dataSource": "交易数据库"
      },
      "4": {
        "name": "信用评分模型——零售",
        "type": "信用风险",
        "description": "针对零售信贷产品的申请评分模型",
        "owner": "消费银行",
        "regulatoryFramework": "公平借贷 (Fair Lending)",
        "modelCategory": "零售",
        "dataSource": "申请数据"
      },
      "2": {
        "name": "LGD 估计模型",
        "type": "信用风险",
        "description": "针对企业贷款的违约损失率(LGD)估计模型",
        "owner": "信用风险团队",
        "regulatoryFramework": "IFRS 9",
        "modelCategory": "企业",
        "dataSource": "历史损失数据"
      },
      "11": {
        "name": "市场风险 VaR 模型",
        "type": "市场风险",
        "description": "用于交易组合风险管理的风险价值(VaR)计算",
        "owner": "市场风险团队",
        "regulatoryFramework": "巴塞尔协议 III (Basel III)",
        "modelCategory": "交易",
        "dataSource": "市场数据源"
      },
      "12": {
        "name": "市场风险希腊字母计算器",
        "type": "市场风险",
        "description": "针对衍生品组合的 Delta、Gamma、Vega 及 Theta 计算",
        "owner": "衍生品交易台",
        "regulatoryFramework": "巴塞尔协议 III (Basel III)",
        "modelCategory": "衍生品",
        "dataSource": "定价引擎"
      },
      "50": {
        "name": "外汇欧式期权定价器",
        "type": "定价模型",
        "description": "针对香草型欧式外汇期权的闭式解定价器",
        "owner": "模型开发",
        "regulatoryFramework": "SR 11-7",
        "modelCategory": "外汇",
        "dataSource": "市场数据源"
      },
      "51": {
        "name": "利率掉期定价器",
        "type": "定价模型",
        "description": "贴现 + 投影曲线掉期定价器与敏感度",
        "owner": "量化研究",
        "regulatoryFramework": "SR 11-7",
        "modelCategory": "利率",
        "dataSource": "曲线构建器"
      },
      "52": {
        "name": "大宗商品欧式期权定价器",
        "type": "定价模型",
        "description": "含校准接口的香草型大宗商品期权定价器"
      }
    },
    "statuses": {
      "Active": "启用中",
      "Draft": "草稿",
      "Deprecated": "已弃用"
    }
  }
}
